<ng-container *ngIf="isModel">
  <app-project-appointment-create
    #inspectionModel
    [modalTitle]="modelTitle"
    [appId]="appointment_details"
    (isOFICreate)="closeModel($event)"
    [appointmentRendor]="appointmentRendor.asObservable()">
  </app-project-appointment-create>
</ng-container>

<div class="appt-page" *ngIf="!isModel">
  <app-my-booking-link *ngIf="pid !== false && !client_id"></app-my-booking-link>
  <!-- Header -->
  <div class="appt-header">
    <h2 class="appt-title">Appointments</h2>
    <div class="d-flex align-items-center gap-2">
      <app-precinct-toggle noun="Appointments"></app-precinct-toggle>
      <button *ngIf="!client_idx" class="_primary-btn" (click)="opened.hide(); openInspection(null)">
        <i class="pi pi-plus mr-2 f-10"></i>Create Appointment
      </button>
    </div>
  </div>

  <!-- Stat cards -->
  <div class="appt-stats">
    <div class="appt-stat">
      <span class="appt-stat__icon appt-stat__icon--green"><i class="pi pi-calendar"></i></span>
      <div class="appt-stat__body">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <p class="appt-stat__label">Total Appointments</p>
          <ng-select
            *ngIf="isStatsPeriodVisible"
            class="appt-stat__period"
            [items]="statsPeriodOptions"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [searchable]="false"
            [(ngModel)]="statsPeriod"
            (change)="applyFilters()">
          </ng-select>
        </div>
        <p class="appt-stat__value">{{ stats.total }}</p>
      </div>
    </div>
    <div class="appt-stat">
      <span class="appt-stat__icon appt-stat__icon--green"><i class="pi pi-calendar-plus"></i></span>
      <div class="appt-stat__body">
        <p class="appt-stat__label">Upcoming</p>
        <p class="appt-stat__value">{{ stats.upcoming }}</p>
      </div>
    </div>
    <div class="appt-stat">
      <span class="appt-stat__icon appt-stat__icon--blue"><i class="pi pi-check-circle"></i></span>
      <div class="appt-stat__body">
        <p class="appt-stat__label">Completed</p>
        <p class="appt-stat__value">{{ stats.completed }}</p>
      </div>
    </div>
    <div class="appt-stat">
      <span class="appt-stat__icon appt-stat__icon--orange"><i class="pi pi-clock"></i></span>
      <div class="appt-stat__body">
        <p class="appt-stat__label">Overdue / Needs Update</p>
        <p class="appt-stat__value appt-stat__value--orange">{{ stats.overdue }}</p>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="appt-filters">
    <div class="appt-filter appt-filter--search">
      <div class="position-relative w-100">
        <input
          type="text"
          [(ngModel)]="keyword"
          [ngModelOptions]="{ standalone: true }"
          id="keywordInput"
          (input)="onSearchInput()"
          name="task-search"
          class="_input-icon w-100 custom-placeholder"
          placeholder="Search client name, project or agent..."
          (keydown.enter)="$event.preventDefault()" />
        <i class="pi pi-search _search-icon"></i>
        <i class="pi pi-times _cross-icon" *ngIf="keyword" (click)="keyword = ''; applyFilters()"></i>
      </div>
    </div>
    <div class="appt-filter" *ngIf="isProjectFilterVisible">
      <label class="appt-filter__label">Project</label>
      <ng-select
        [items]="projectOptions"
        bindLabel="name"
        bindValue="id"
        placeholder="All Projects"
        [(ngModel)]="projectSearch"
        (change)="applyFilters()">
      </ng-select>
    </div>
    <div class="appt-filter">
      <label class="appt-filter__label">Appointment Type</label>
      <ng-select
        [items]="appointment_type"
        bindLabel="tag_name"
        bindValue="tag_name"
        placeholder="All Types"
        [(ngModel)]="appSearch"
        (change)="applyFilters()">
      </ng-select>
    </div>
    <div class="appt-filter">
      <label class="appt-filter__label">Agent</label>
      <ng-select
        [items]="originalAssigns"
        bindLabel="full_name"
        bindValue="_id"
        [multiple]="true"
        [closeOnSelect]="false"
        placeholder="All Agents"
        [(ngModel)]="agentSearch"
        (change)="applyFilters()">
      </ng-select>
    </div>
    <div class="appt-filter">
      <label class="appt-filter__label">Date Range</label>
      <app-remmi-date-range #dateRangeRef [isSevenDays]="false" (applyDateFilter)="onDateFilter($event)"></app-remmi-date-range>
    </div>
    <button class="_outline-btn appt-filters__reset" (click)="clearSearch()">Reset</button>
  </div>

  <!-- Tabs -->
  <!-- Same secondary-tabs strip as Allocations (Lot Allocation | Car Park / Storage). -->
  <div class="appt-tabs-row">
    <div class="d-flex align-items-center secondary-tabs b-b-tabs flex-grow-1">
      <ul class="nav tools-tab-nav w-100 align-items-center" role="tablist">
        <li class="position-relative" *ngFor="let tab of tabs; let isLast = last">
          <a href="javascript:void(0)" [class.active]="activeTab === tab.value" (click)="selectTab(tab.value)">
            {{ tab.label }}
            <span class="appt-tab__badge" *ngIf="tab.value === 'overdue' && tabCounts.overdue > 0">{{ tabCounts.overdue }}</span>
          </a>
          <div class="right-boarder" *ngIf="!isLast"></div>
        </li>
      </ul>
    </div>
    <div *ngIf="cancelled_app?.length > 0">
      <button class="_outline-btn f-12" (click)="op.toggle($event)">Bulk Edit ({{ cancelled_app.length }})</button>
      <p-overlayPanel #op>
        <ng-template pTemplate="content">
          <p (click)="cancelledAppointment(); op.hide()" class="bulk-op pb-2">Cancel</p>
          <p (click)="attendedAppointment(); op.hide()" class="bulk-op">Attended</p>
        </ng-template>
      </p-overlayPanel>
    </div>
  </div>

  <!-- Table — cells use div/span, not <p>: the global `p` rule forces 12px/500 with !important. -->
  <div class="appt-table">
    <p-table [value]="pagedAppointments" [paginator]="false" responsiveLayout="scroll" styleClass="appt-grid">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 48px" />
          <col style="width: 230px" />
          <col style="width: 140px" />
          <col style="width: 180px" />
          <col style="width: 160px" />
          <col style="width: 180px" />
          <col style="width: 120px" />
          <col style="width: 90px" />
          <col style="width: 150px" />
          <col style="width: 90px" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-checkbox [binary]="true" [ngModel]="isPageChecked" (onChange)="togglePageChecked($event.checked)"></p-checkbox>
          </th>
          <th>Client Name</th>
          <th>Project</th>
          <th>
            <span class="appt-sort" (click)="toggleSort()">
              Appointment Time
              <i class="pi" [ngClass]="sortDirection === 'asc' ? 'pi-arrow-up' : 'pi-arrow-down'"></i>
            </span>
          </th>
          <th>Type</th>
          <th>Agent</th>
          <th>Status</th>
          <th class="text-center">Attended</th>
          <th>Created</th>
          <th class="text-center">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-appointment>
        <tr class="cursor-pointer" [class.appt-row--checked]="appointment.is_checked">
          <td>
            <p-checkbox (onChange)="cancelApp()" [binary]="true" [(ngModel)]="appointment.is_checked"></p-checkbox>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <ng-container *ngIf="appointment?.clients?.length > 0; else no_client">
              <div class="appt-client" *ngFor="let client of appointment.clients.slice(0, 2)">
                <div class="appt-client__name">{{ client?.full_name }}</div>
                <span class="appt-chip" *ngIf="client?.lead_status">{{ client.lead_status }}</span>
              </div>
              <span class="appt-more" *ngIf="appointment.clients.length > 2" [pTooltip]="getNameList(appointment.clients, 2)" tooltipPosition="top">
                +{{ appointment.clients.length - 2 }} more
              </span>
            </ng-container>
            <ng-template #no_client>
              <div class="appt-client__name">{{ ProjectList?.Project_Name }}</div>
            </ng-template>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <div class="appt-text">{{ appointment.projectLabel }}</div>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <div class="appt-time">
              <i class="pi pi-calendar appt-time__icon"></i>
              <div>
                <div class="appt-time__date">{{ appointment.event?.start?.dateTime | date: 'd MMM y' }}</div>
                <div class="appt-time__range">
                  {{ getTimeFormat(appointment.event?.start?.dateTime) }} – {{ getTimeFormat(appointment.event?.end?.dateTime) }}
                </div>
              </div>
            </div>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <span class="appt-pill" [ngClass]="appointment.typeClass" *ngIf="appointment.app_type; else noValue">
              {{ appointment.app_type }}
            </span>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <div class="appt-agent" *ngIf="appointment?.agents?.length > 0; else noValue">
              <span class="appt-agent__avatar">{{ appointment.agentInitials }}</span>
              <span class="appt-agent__name">{{ appointment.agents[0]?.full_name }}</span>
              <span
                class="appt-agent__more"
                *ngIf="appointment.agents.length > 1"
                [pTooltip]="getNameList(appointment.agents, 1)"
                tooltipPosition="top">
                +{{ appointment.agents.length - 1 }}
              </span>
            </div>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <span class="appt-pill status-pill--{{ appointment.status }}">
              {{ appointment.status === 'upcoming' ? 'Upcoming' : appointment.status === 'overdue' ? 'Overdue' : 'Completed' }}
            </span>
          </td>
          <td class="text-center" (click)="getApptDetails(appointment, $event)">
            <span
              pTooltip="{{ appointment?.tooltip }}"
              tooltipPosition="top"
              class="appt-dot"
              [class.appt-dot--done]="appointment.status === 'completed'"></span>
          </td>
          <td (click)="opened.hide(); projectDetails(appointment)">
            <div class="appt-created__date">{{ appointment.createdAt | date: 'd MMM y' }}</div>
            <div class="appt-created__by" *ngIf="appointment.createdByName || getStaffName(appointment.created_by) as createdBy">
              by {{ createdBy }}
            </div>
          </td>
          <td>
            <div class="appt-actions">
              <button type="button" class="appt-action" pTooltip="Edit" tooltipPosition="top" (click)="openInspection(appointment)">
                <i class="pi pi-pencil"></i>
              </button>
              <button
                type="button"
                class="appt-action appt-action--danger"
                pTooltip="Delete"
                tooltipPosition="top"
                (click)="deleteAppointment(appointment)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">
            <div class="appt-empty">
              <i class="pi pi-calendar-times"></i>
              <span>No appointments found</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <ng-template #noValue><span class="appt-muted">—</span></ng-template>

    <!-- Footer / pagination -->
    <div class="appt-footer">
      <span>Showing {{ totalRecords }} {{ totalRecords === 1 ? 'appointment' : 'appointments' }}</span>
      <div class="appt-pager">
        <span>Rows per page</span>
        <ng-select
          class="appt-pager__size"
          [items]="pageSizeOptions"
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="pageSize"
          (change)="applyFilters()">
        </ng-select>
        <span class="appt-pager__range">{{ pageRangeLabel }}</span>
        <button type="button" class="appt-pager__btn" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          <i class="pi pi-angle-left"></i>
        </button>
        <button type="button" class="appt-pager__btn" [disabled]="pageIndex >= pageCount - 1" (click)="goToPage(pageIndex + 1)">
          <i class="pi pi-angle-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Attendance / like popup (opened from the Attended column) -->
  <p-overlayPanel #opened [dismissable]="false" [zIndex]="0">
    <ng-template pTemplate="content">
      <form [formGroup]="attendee_liked" style="width: 300px">
        <div class="flex align-items-center">
          <div class="flex align-items-center green-dot w-50">
            <p-radioButton name="appt_status" value="completed" formControlName="appt_status" inputId="ingredient1"></p-radioButton>
            <label for="ingredient1" class="ml-2">Completed</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="appt_status" value="pending" formControlName="appt_status" inputId="ingredient2"></p-radioButton>
            <label for="ingredient2" class="ml-2">Pending</label>
          </div>
        </div>
        <div class="mt-2 flex align-items-center">
          <div class="w-50 flex align-items-center yellow-dot">
            <p-radioButton name="appt_status" value="rescheduled" formControlName="appt_status" inputId="ingredient1"></p-radioButton>
            <label for="ingredient1" class="ml-2">Rescheduled</label>
          </div>
          <div class="flex align-items-center red-dot">
            <p-radioButton name="appt_status" value="cancelled" formControlName="appt_status" inputId="ingredient2"></p-radioButton>
            <label for="ingredient2" class="ml-2">Cancelled</label>
          </div>
        </div>
        <div class="mt-3 flex align-items-center justify-content-between">
          <div class="flex align-items-center">
            <div class="mr-3">
              <i
                class="pi pi-thumbs-up f-18 cursor-pointer"
                (click)="likDislike_icon = 'pi pi-thumbs-up'"
                [ngClass]="{ 'like-dislike': likDislike_icon === 'pi pi-thumbs-up' }"></i>
            </div>
            <div>
              <i
                class="pi pi-thumbs-down f-18 cursor-pointer"
                (click)="likDislike_icon = 'pi pi-thumbs-down'"
                [ngClass]="{ 'like-dislike': likDislike_icon === 'pi pi-thumbs-down' }"></i>
            </div>
          </div>
          <div>
            <i class="pi pi-plus f-14 cursor-pointer" (click)="this.lmService.tag_manager = !this.lmService.tag_manager"></i>
          </div>
        </div>
        <div class="mt-3" *ngIf="!likDislike_icon || likDislike_icon === 'pi pi-thumbs-up'">
          <re-multiSelect
            [options]="unit_list"
            formControlName="lots"
            optionLabel="lot_name"
            optionValue="_id"
            placeholder="Select Lot"
            (onUpdate)="selectUnit()">
          </re-multiSelect>
        </div>
        <div class="d-flex align-items-center flex-wrap appt-tags">
          <div
            class="mr-1 mb-1 f-12 primary-chip cp p-chip d-inline-flex align-items-center"
            *ngFor="let item of todo; let i = index"
            [pTooltip]="item?.type">
            <div class="p-chip-text">{{ item }}</div>
            <i class="pi pi-times-circle cp ml-2" (click)="removePublicTag(i)"></i>
          </div>
          <input
            type="text"
            class="site-input"
            [(ngModel)]="inputValue"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="addTag()"
            class="f-14 w-50 border-0" />
        </div>
        <p class="pt-1">Press enter after typing tag name</p>
        <div class="mt-3">
          <div class="w-100 _paragraph">
            <ckeditor formControlName="appt_note" [editor]="Editor"></ckeditor>
          </div>
        </div>
      </form>
      <div class="text-right mt-3">
        <button class="_cancel-btn mr-2" (click)="attendee_liked.reset(); opened.hide()">Cancel</button>
        <button class="_outline-btn" (click)="saveAttendLike(); opened.hide()">Save</button>
      </div>
    </ng-template>
  </p-overlayPanel>
</div>

<!-- Project Detail Model -->

<div class="OFIDailog">
  <p-dialog header="{{ listing_details?.Project_Name }}" [(visible)]="propertyModel" [draggable]="false" [modal]="true" [style]="{ width: '800px' }">
    <ng-container *ngIf="listing_details?.project_gallery?.length > 0; else elsePart">
      <div class="mt-3">
        <img src="{{ S3Path + listing_details?.project_gallery[0]?.path }}" alt="" class="main-images" id="imageId" />
      </div>
    </ng-container>
    <ng-template #elsePart>
      <div class="d-flex justify-content-center">
        <img [src]="common_images?.image_not_found" class="no-images" />
      </div>
    </ng-template>
    <ng-container>
      <div class="d-flex align-items-baseline justify-content-between">
        <p class="f-14 mt-4">Contact Details</p>
        <div class="position-relative with-left-icon">
          <i class="f-14 pi pi-search cp-search" *ngIf="!query"></i>
          <input
            type="text"
            placeholder="Search"
            class="site-input"
            [(ngModel)]="query"
            [ngModelOptions]="{ standalone: true }"
            (input)="searchLead()" />
          <i (click)="this.listing_details = this.listing_details_copy; query = null" class="ml-2 pi pi-times cp f-10" *ngIf="query"></i>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="d-flex align-items-center">
          <p>Attended:</p>
          <p>&nbsp;{{ listing_details?.total_attendee }}</p>
        </div>
        <div class="d-flex align-items-center">
          <p>Liked:</p>
          <p>&nbsp;{{ listing_details?.total_likes }}</p>
        </div>
        <div class="d-flex align-items-center">
          <p>Dislike:</p>
          <p>&nbsp;{{ listing_details?.total_dislikes }}</p>
        </div>
      </div>
      <div class="mt-2" style="max-height: 150px; overflow: auto">
        <p-table [value]="listing_details?.leads" [(selection)]="selectedRows">
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width: 70px" />
              <col style="width: 120px" />
              <col style="width: 120px" />
              <col style="width: 180px" />
              <col style="width: 100px" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="pl-0">
                <p>Attended</p>
              </th>
              <th>
                <p>Name</p>
              </th>
              <th>
                <p>Phone</p>
              </th>
              <th>
                <p>Email</p>
              </th>
              <th class="text-right"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-contact>
            <tr class="cursor-pointer">
              <td class="pl-0">
                <div>
                  <p-checkbox (onChange)="selectColumn(contact)" [(ngModel)]="contact.attendee" [binary]="true"></p-checkbox>
                </div>
              </td>
              <td (click)="contactDetails(contact)" class="pl-3">
                <p>{{ contact.full_name }}</p>
              </td>
              <td (click)="contactDetails(contact)" class="pl-3">
                <p>{{ contact.mobile_no }}</p>
              </td>
              <td (click)="contactDetails(contact)" class="pl-3">
                <p>{{ contact.email }}</p>
              </td>
              <td class="text-right">
                <div>
                  <img [src]="common_images?.edit_icon" alt="" class="pencil-cross" (click)="editRegister(contact)" />
                  <i
                    (click)="likeDislikeLead(contact, true)"
                    class="pi pi-thumbs-up mr-2 f-14"
                    [ngClass]="{ 'like-dislike': contact?.like_dislike === true }"></i>
                  <i
                    (click)="likeDislikeLead(contact, false)"
                    class="pi pi-thumbs-down f-14"
                    [ngClass]="{ 'like-dislike': contact?.like_dislike === false }"></i>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">No record found</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-4">
        <button class="_outline-btn mr-2" (click)="cancelledAppointment()">Cancel Appointment</button>
        <button class="_outline-btn mr-2" (click)="registerModelPopup()">Register</button>
      </div>
    </ng-container>
  </p-dialog>
</div>

<!-- contact Detail Model -->

<div class="OFIDailog">
  <p-dialog [(visible)]="contactModel" [style]="{ width: '550px' }" [draggable]="false">
    <div>
      <p class="contact-title f-18" title="{{ contact_related?.full_name }}">
        {{ contact_related?.first_name?.charAt(0) + '' + contact_related?.last_name?.charAt(0) }}
      </p>
      <p class="f-14 text-center">{{ contact_related?.full_name }}</p>
    </div>
    <div style="margin-top: 20px">
      <p class="f-14 _fw-600">Project Leads</p>
      <ng-container *ngIf="contact_related?.projects?.length > 0; else no_lead">
        <ng-container *ngFor="let item of contact_related?.projects">
          <div class="d-flex align-items-center mt-2">
            <ng-container *ngIf="item?.project_gallery?.length > 0; else elseParts">
              <div>
                <img src="{{ S3Path + item?.project_gallery[0]?.path }}" alt="" width="60px" height="40px" id="imageId" />
              </div>
            </ng-container>
            <ng-template #elseParts>
              <div class="d-flex justify-content-center">
                <img [src]="common_images?.image_not_found" class="no-image" />
              </div>
            </ng-template>
            <div>
              <p class="ml-2">{{ item?.Project_Name }}</p>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #no_lead>
        <p class="mt-1">No project lead</p>
      </ng-template>
    </div>
    <div class="mt-3">
      <p class="f-14 _fw-600">Contact Notes</p>
      <ng-container *ngIf="lead_notes?.length > 0; else no_notes">
        <ng-container *ngFor="let note of lead_notes; let i = index">
          <div class="d-flex mt-2" *ngIf="contactNote === i">
            <p #custom_Editor1 class="editor" [(innerHTML)]="note.text" contenteditable></p>
            <button class="_outline-btn ml-2" (click)="updateNotes(note); contactNote = null">update</button>
          </div>
          <div class="d-flex mt-2" *ngIf="contactNote !== i">
            <div class="w-100">
              <p [innerHTML]="note?.text"></p>
            </div>
            <div class="d-flex align-items-center">
              <img [src]="common_images?.edit_icon" width="15" alt="" class="mr-2 cursor-pointer" (click)="contactNote = i" />
              <img [src]="common_images?.contract_delete" width="15" alt="" class="cursor-pointer" (click)="deleteNotes(note)" />
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #no_notes>
        <p class="mt-1">No notes</p>
      </ng-template>
    </div>
  </p-dialog>
</div>

<!-- Register Model -->

<div class="OFIDailog">
  <p-dialog
    header="{{ this.updateRegister_user?._id ? 'Update Clients' : 'Register Clients' }}"
    [(visible)]="registerModel"
    [draggable]="false"
    [modal]="true"
    [style]="{ width: '680px' }">
    <form [formGroup]="register_property">
      <div class="row mt-3">
        <div class="col-sm-4">
          <p class="mb-2">Name</p>
          <re-multiselect
            [module]="'contacts'"
            [placeholder]="'Name'"
            [truncate]="25"
            [isMultiple]="false"
            [isClear]="true"
            [isFullObject]="true"
            [selected_ids]="register_property.controls['first_name'].value"
            (onUpdate)="contactSelection($event)"
            [required_class]="register_submit && register_property.controls['first_name'].hasError('required') ? true : false"
            [style]="{ width: '100%' }">
          </re-multiselect>
        </div>
        <div class="col-sm-4">
          <p class="mb-2">Mobile</p>
          <input
            type="text"
            formControlName="mobile_no"
            placeholder="Mobile"
            [ngClass]="{
              '_input-error': register_submit && register_property.controls['mobile_no'].hasError('required'),
            }" />
        </div>
        <div class="col-sm-4">
          <p class="mb-2">Email</p>
          <input
            type="email"
            formControlName="email"
            placeholder="Email"
            [ngClass]="{
              '_input-error':
                register_submit &&
                (register_property.controls['email'].hasError('required') || register_property.controls['email'].hasError('email')),
            }" />
        </div>
        <div class="col-sm-12 mt-2">
          <p class="mb-2">Project Details</p>
          <input type="text" class="site-input" formControlName="project_details" placeholder="Project Details" />
        </div>
        <div class="col-sm-12 mt-3 d-flex align-items-center">
          <p-checkbox formControlName="send_link" [binary]="true" inputId="ny"></p-checkbox>
          <p>Send Registration Link</p>
        </div>
        <div class="col-sm-12 _paragraph mt-2">
          <p class="mb-2">Notes</p>
          <p #custom_Editor2 class="editor" [(innerHTML)]="register_user_note" contenteditable></p>
        </div>
        <div class="col-sm-12 mt-2">
          <p>Audio Notes</p>
          <div class="mt-2 mb-2">
            <div *ngIf="!isRecording" class="d-flex align-items-center">
              <img
                [src]="common_images?.record_icon"
                pTooltip="Voice note"
                tooltipPosition="top"
                width="30px"
                height="30px"
                class="cursor-pointer"
                (click)="startRecording()" />
              <p class="ml-2">Record your note.</p>
            </div>
            <div *ngIf="isRecording" class="d-flex align-items-center">
              <img
                [src]="common_images?.stop_icon"
                pTooltip="Stop Recording"
                tooltipPosition="top"
                width="30px"
                height="30px"
                class="cursor-pointer"
                (click)="stopRecording()" />
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <p>Timestamp: {{ timeStamp | date: 'd MMM y' }}</p>
        </div>
      </div>
      <div class="text-right">
        <button class="_primary-btn" (click)="userRegister(this.updateRegister_user?._id ? 'update' : 'create')">
          {{ this.updateRegister_user?._id ? 'Update' : 'Register' }}
        </button>
      </div>
    </form>
  </p-dialog>
</div>

<!-- exist user -->
<app-possible-duplicate-contact
  [(visible)]="contactConflict"
  [contacts]="cContacts"
  [newContact]="duplicateContactDraft"
  (assign)="convertToContact(conflictLeadId, $event.contactId, false, true, $event.addAsAlternate, $event.label)"
  (createNew)="convertToContact(conflictLeadId, null, true, true)"></app-possible-duplicate-contact>

<!-- prompt -->
<div class="OFIDailog">
  <p-dialog header="Appointment Exist" [(visible)]="isExistPrompt" [draggable]="false" [modal]="true" [style]="{ width: '450px' }">
    <div class="mt-3">
      <p>This contact is already registered for an appointment.</p>
    </div>
    <div class="flexCenterEnd mt-4">
      <button class="_outline-btn" (click)="isExistPrompt = false">Ok</button>
    </div>
  </p-dialog>
</div>

<!-- tags -->
<p-dialog
  [styleClass]="'noHeader'"
  [showHeader]="false"
  [(visible)]="lmService.tag_manager"
  [style]="{ width: '350px' }"
  [baseZIndex]="999999"
  [position]="'right'"
  styleClass="tag-sidebar-manager">
  <div class="px-2 py-2">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="f-18">Project Tags</h3>
      <div class="d-flex">
        <button class="_view-btn p-2 h-auto" type="button" (click)="new_tag_popup = true">
          <i class="pi pi-plus f-12"></i>
        </button>
        <button class="ml-3 _view-btn p-2 h-auto" type="button" (click)="closeTagManger()">
          <i class="pi pi-times f-12"></i>
        </button>
      </div>
    </div>
    <div class="mb-4">
      <div class="w-100 my-2 mr-3 position-relative with-right-icon" style="min-width: 230px">
        <i class="f-14 pi pi-search cp-search" *ngIf="!keywordTags"></i>
        <input class="site-input" type="text" #searchKeyword [(ngModel)]="keywordTags" placeholder="Search Tags" (input)="filterItem()" />
        <i class="pi pi-times cp" *ngIf="keywordTags" (click)="resetTagSearch()"></i>
      </div>
    </div>
    <ng-container *ngFor="let type of preference_tags; let ind = index">
      <div *ngIf="type?._id != 'createnew'">
        <div class="box-header mt-2" (click)="toggleBox(type)">
          <p>{{ type.name }}</p>
          <i class="pi f-12" [ngClass]="{ 'pi-minus': type.isOpen, 'pi-plus': !type.isOpen }"></i>
        </div>
        <div class="box-content" [hidden]="!type.isOpen">
          <div class="d-flex flex-wrap">
            <ng-container *ngFor="let tag of type?.data; let i = index">
              <div
                class="d-flex align-items-center mt-2 tag-dev mr-2 cursor-pointer"
                (dblclick)="addTagInForm(0, tag)"
                pTooltip="Double click to add"
                tooltipPosition="top">
                <p>{{ tag?.tag_name }}</p>
                <i class="pi pi-times-circle pl-2" (click)="type.data.splice(i, 1)"></i>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</p-dialog>

<!-- Tag Type -->
<p-dialog
  [(visible)]="newTagTypePopup"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div>
    <div>
      <div class="mt-2">
        <label class="mb-1">Tag Type</label>
        <input type="text" placeholder="Tag type name" [(ngModel)]="tag_type" class="site-input" />
      </div>
    </div>

    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="tag_type = null; newTagTypePopup = false">Cancel</button>
      <button class="_outline-btn" [class.disabled]="!tag_type" (click)="createTagType()">Add</button>
    </div>
  </div>
</p-dialog>

<!-- New tag -->
<p-dialog
  [(visible)]="new_tag_popup"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div class="p-2">
    <div>
      <div class="mt-2">
        <label class="mb-1 px-1 d-flex align-items-center justify-content-between"> Tag Type</label>
        <div class="dropdown-with-create-new" *ngIf="preference_tags.length > 0">
          <ng-select
            [items]="preference_tags"
            bindLabel="name"
            [searchable]="true"
            [(ngModel)]="tag_type"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Tag Type"
            class="view-w-100"
            (change)="isNewTypeModel($event)"
            [resetFilterOnHide]="true">
          </ng-select>
          <p class="px-1 mt-1 f-10">Select a module to see its tag types</p>
        </div>
      </div>
      <div class="mt-2 chips-custom">
        <label class="mb-1 px-1 w-100 d-flex align-items-center justify-content-between">Tags*</label>
        <div>
          <p-chips [(ngModel)]="new_tag" placeholder="Add Multiple Tags" styleClass="w-100" (onAdd)="pushTagToArray($event)"></p-chips>
          <p class="px-1 mt-1 f-10">Press enter after typing tag name</p>
        </div>
      </div>
    </div>
    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="module_type = null; new_tag = []; tag_type = null; new_tag_popup = false">Cancel</button>
      <button class="preview-btn" [class.disabled]="!new_tag?.length || !tag_type || submit" (click)="submit = true; createTag()">Add</button>
    </div>
  </div>
</p-dialog>
